import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n, { checkIsChinaIp } from './lang'

// 导入悬浮咨询组件（核心新增）
import FloatContact from './components/common/FloatContact.vue'  

import './assets/iconfont/iconfont.css'
import './assets/styles/font.css'
import './assets/styles/global.css'

import AOS from 'aos'
import 'aos/dist/aos.css'

import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css/bundle'

// 🔴 新增：引入你封装的 api.js
import apiModule from './config/api.js' // 路径确认和你的 api.js 一致！

const app = createApp(App)

app.use(i18n)

// 修复：组件名改为多单词（VwSwiper/VwSwiperSlide）
app.component('VwSwiper', Swiper)
app.component('VwSwiperSlide', SwiperSlide)

// 核心新增：注册全局悬浮咨询组件
app.component('FloatContact', FloatContact)

// 🔴 新增：把封装的 api 挂载到 Vue 3 全局
app.config.globalProperties.$api = apiModule.api
// 可选：挂载 baseUrl/imgUrl 配置（需要的话加）
app.config.globalProperties.$baseConfig = apiModule

async function initLanguage() {
  const savedLang = localStorage.getItem('siteLang')
  if (savedLang) {
    i18n.global.locale.value = savedLang
    return
  }
  try {
    const isChinaIp = await checkIsChinaIp()
    const lang = isChinaIp ? 'zh-CN' : 'en'
    i18n.global.locale.value = lang
    localStorage.setItem('siteLang', lang)
  } catch (error) {
    i18n.global.locale.value = 'zh-CN'
    localStorage.setItem('siteLang', 'zh-CN')
  }
}

initLanguage()

app.config.globalProperties.$i18nInstance = i18n

initLanguage().then(() => {
  AOS.init({
    duration: 800,
    easing: 'ease-in-out',
    once: false,
    mirror: true,
    offset: 100
  })
})

app.use(router).mount('#app')